import {Props} from '../model';
import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {datePipe} from '../../../../shared/pipes/date';
import {dateFormats} from '../../../../shared/constants/date';
import {PollsButton} from '../button';
import {Text} from '../../../../shared/components/text';

export default (props: Props) => {
  const styles = useStyles(({theme}) => ({
    container: {},
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      borderBottomWidth: 1,
      borderBottomColor: theme.color.borderColor,
      borderStyle: 'solid',
    },
    col: {
      paddingVertical: 12,
      paddingHorizontal: 24,
    },
    colHead: {
      paddingVertical: 4,
    },
    colHeadText: {
      ...theme.fonts.body,
      color: theme.color.labelText,
    },
    colHeadTextCenter: {
      textAlign: 'center',
    },
    colTheme: {
      flexShrink: 1,
      flexGrow: 1,
    },
    colDates: {
      flexBasis: 204,
      paddingLeft: 0,
      paddingRight: 0,
      marginRight: 40,
    },
    colAction: {
      flexBasis: 200,
      paddingLeft: 0,
      paddingRight: 0,
    },
    name: theme.fonts.h5Light,
    datesText: {
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
      textAlign: 'center',
    },
    buttonAction: {
      width: 140,
    },
  }));
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={[styles.col, styles.colHead, styles.colTheme]}>
          <Text testID='polls-theme-column-name-id' style={styles.colHeadText}>
            Тема
          </Text>
        </View>
        <View style={[styles.col, styles.colHead, styles.colDates]}>
          <Text testID='polls-date-column-name-id' style={[styles.colHeadText, styles.colHeadTextCenter]}>
            Сроки проведения
          </Text>
        </View>
        <View style={[styles.col, styles.colHead, styles.colAction]} />
      </View>
      {props.polls?.map((item, id) => (
        <View style={styles.row} key={item.id}>
          <View style={[styles.col, styles.colTheme]}>
            <Text testID={`polls-theme-column-name-value-${id}-id`} style={styles.name}>
              {item.topic}
            </Text>
          </View>
          <View style={[styles.col, styles.colDates]}>
            <Text testID={`polls-date-column-name-value-${id}-id`} style={styles.datesText} numberOfLines={1}>
              {datePipe(item.startDate, dateFormats.shortDate)} - {datePipe(item.endDate, dateFormats.shortDate)}
            </Text>
          </View>
          <View style={[styles.col, styles.colAction]}>
            <PollsButton poll={item} />
          </View>
        </View>
      ))}
    </View>
  );
};
